module.exports = __webpack_public_path__ + "img/Zugführer_Sanitätszug.a14aef33.svg";